module.exports = __webpack_public_path__ + "img/objQrcode.fd9c4cfc.svg";